import { render, staticRenderFns } from "./MyTopicInfo.vue?vue&type=template&id=b9f12a94&scoped=true&"
import script from "./MyTopicInfo.vue?vue&type=script&lang=js&"
export * from "./MyTopicInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyTopicInfo.vue?vue&type=style&index=0&id=b9f12a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f12a94",
  null
  
)

export default component.exports